import { useSyncExternalStore } from "react"

import { logger } from "../modules/logger/logger"

let hidden: string
let visibilityChange: string

// https://gist.github.com/AnishLushte07/4d436dac2fac1ed6f9cae8a6a88eeb68
// Alternative solution: https://github.com/jpalumickas/use-window-focus/blob/main/src/index.ts
if (typeof document !== "undefined" && typeof document.hidden !== "undefined") {
  hidden = "hidden"
  visibilityChange = "visibilitychange"
} else if (
  typeof document !== "undefined" &&
  typeof document.msHidden !== "undefined"
) {
  hidden = "msHidden"
  visibilityChange = "msvisibilitychange"
} else if (
  typeof document !== "undefined" &&
  typeof document.webkitHidden !== "undefined"
) {
  hidden = "webkitHidden"
  visibilityChange = "webkitvisibilitychange"
}

function getServerSnapshot(): boolean {
  return true
}

function getSnapshot(): boolean {
  if (typeof document === "undefined") return true
  return document.visibilityState === "visible" && document.hasFocus()
}

function subscribe(onStoreChange: ()=> void) {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return ()=> {}
  }
  const handleVisibilityChange = ()=> {
    logger({
      input: `handleVisibilityChange | hidden: ${document[hidden]} | visibilityChange: ${visibilityChange} | document.visibilityState: ${document.visibilityState} | document.hasFocus(): ${document.hasFocus()}`,
      level: "info",
    })
    onStoreChange()
  }
  document.addEventListener(visibilityChange, handleVisibilityChange)
  window.addEventListener("focus", onStoreChange)
  window.addEventListener("blur", onStoreChange)
  return ()=> {
    document.removeEventListener(visibilityChange, handleVisibilityChange)
    window.removeEventListener("focus", onStoreChange)
    window.removeEventListener("blur", onStoreChange)
  }
}

export const useHasFocus = ()=>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
